export const BASE_URL = '/fast-sync';

export const GET_LIST_FAST_SYNC_LOG = '/';
export const RE_SYNC_DATA_ERROR_BY_ID = 're-sync';
